// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import { getUserById, ReportUser } from "../api/api";
// import socketServices from "../api/socket";
// import { environment } from "../../environments/environments";
// import "../Chat/Chat.css";

// const Chat = () => {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const [messages, setMessages] = useState([]);
//   const [inputText, setInputText] = useState("");
//   const [currUser, setCurrUser] = useState(null);
//   const [chatUser, setChatUser] = useState(null);
//   const [sending, setSending] = useState(false);
//   const [reportModalVisible, setReportModalVisible] = useState(false);
//   const [reportMessageId, setReportMessageId] = useState("");
//   const [reportText, setReportText] = useState("");
//   const [selectedReason, setSelectedReason] = useState("");
//   const [emptyMessageModalVisible, setEmptyMessageModalVisible] =
//     useState(false);
//   const [token, setToken] = useState("");
//   const chatContainerRef = useRef(null);

//   useEffect(() => {
//     const fetchData = async () => {
//       const userData = localStorage.getItem("currentUser");
//       const parsedUserData = JSON.parse(userData);
//       setCurrUser(parsedUserData);
//       const storedToken = localStorage.getItem("jwtToken");
//       console.log("tokenn_generated", storedToken);
//       setToken(storedToken || "");
//       if (id) {
//         const user = await getUserById({ user_id: id });
//         setChatUser(user?.data);
//       }
//     };
//     fetchData();
//   }, [id]);

//   useEffect(() => {
//     if (!currUser || !chatUser) return;
//     socketServices.initializeSocket();
//     socketServices.emit("userConnected", currUser._id);
//     const messageListener = (data) => {
//       if (typeof data === "object" && data !== null) {
//         setMessages((prev) => (Array.isArray(prev) ? [...prev, data] : [data]));
//       }
//     };
//     socketServices.on("receiveMessage", messageListener);
//     loadChats();
//     return () => {
//       socketServices.emit("userDisconnected", currUser._id);
//     };
//   }, [currUser, chatUser]);

//   const loadChats = async () => {
//     try {
//       const res = await fetch(
//         `${environment.chatBaseUrl}/chats/${currUser._id || currUser.id}/${
//           chatUser._id || chatUser.id
//         }`
//       );
//       const chats = await res.json();
//       if (Array.isArray(chats)) {
//         if (chats.length === 0) {
//           setEmptyMessageModalVisible(true);
//         }
//         setMessages(chats);
//       } else {
//         console.warn("Unexpected response from chat API:", chats);
//         setMessages([]);
//       }
//     } catch (error) {
//       console.error("Error fetching chats:", error);
//       setMessages([]);
//     }
//   };

//   const sendMessage = async () => {
//     if (!inputText.trim() || sending) return;
//     setSending(true);
//     const messageData = {
//       from: currUser._id || currUser.id,
//       to: chatUser._id || chatUser.id,
//       msg: inputText.trim(),
//       jwtsecret: token,
//       connected_user_status: "approved",
//       chatmode: "user",
//       sender_id: currUser._id || currUser.id,
//     };
//     console.log("messageData22222222222222", messageData);
//     try {
//       const response = await fetch(`${environment.chatBaseUrl}/send-message`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(messageData),
//       });

//       const responseData = await response.json();
//       if (responseData) {
//         setInputText("");
//         socketServices.emit("sendMessage", messageData);
//       }
//     } catch (error) {
//       console.error("Error sending message:", error);
//     } finally {
//       setSending(false);
//     }
//   };

//   useEffect(() => {
//     if (chatContainerRef.current) {
//       chatContainerRef.current.scrollTop =
//         chatContainerRef.current.scrollHeight;
//     }
//   }, [messages]);

//   const handleReportMessage = (messageId) => {
//     setReportMessageId(messageId);
//     setReportText("");
//     setSelectedReason("");
//     setReportModalVisible(true);
//   };

//   const handleSubmitReport = async () => {
//     const value = {
//       user_id: currUser?._id || currUser?.id,
//       reported_user_id: chatUser._id || chatUser.id,
//       message_id: reportMessageId,
//       description: reportText,
//       reason: selectedReason,
//       reported_type: "user",
//       reporter_type: "user",
//     };
//     try {
//       const res = await ReportUser(value);
//       console.log("resss", res);
//       if (res?.success) {
//         alert("Reported Successfully");
//         setReportModalVisible(false);
//       }
//     } catch (error) {
//       console.error("Report error:", error);
//     }
//   };

//   const renderMessage = (message) => {
//     const isSentByCurrentUser = message.sender_id === currUser._id;
//     return (
//       <div
//         key={message._id || message.timestamp}
//         className={`User-chat-message ${
//           isSentByCurrentUser ? "sent-message" : "received-message"
//         }`}
//       >
//         <div className="User-message-content">
//           <p className="User-message-text">{message.msg}</p>
//           <span className="User-message-time">
//             {new Date(message.timestamp).toLocaleTimeString([], {
//               hour: "2-digit",
//               minute: "2-digit",
//             })}
//           </span>
//         </div>
//         {!isSentByCurrentUser && (
//           <button
//             onClick={() => handleReportMessage(message._id)}
//             className="User-report-button"
//           >
//             <i className="User-fas User-fa-ellipsis-v"></i>
//           </button>
//         )}
//       </div>
//     );
//   };

//   if (!currUser || !chatUser) return <div>Loading chat...</div>;

//   return (
//     <div className="User-chat-container">
//       <div className="User-chat-header">
//         <div className="User-user-profile">
//           <img
//             src={`${environment.url}/uploads/users/${chatUser?.more_images?.[0]}`}
//             alt="Profile"
//             className="User-profile-image"
//           />
//           <div>
//             <h3>{chatUser?.name}</h3>
//           </div>
//         </div>
//       </div>

//       <div className="User-chat-messages" ref={chatContainerRef}>
//         {/* {messages
//           .filter((item) => item.msg?.trim())
//           .map((item) => renderMessage(item))} */}
//         {Array.isArray(messages) &&
//           messages
//             .filter((item) => item?.msg?.trim?.())
//             .map((item) => renderMessage(item))}
//       </div>

//       <div className="User-message-input-container">
//         <input
//           type="text"
//           placeholder="Type a message..."
//           value={inputText}
//           onChange={(e) => setInputText(e.target.value)}
//         />
//         {inputText && (
//           <button onClick={sendMessage} className="User-send-message-button">
//             {/* <i className="User-fas User-fa-paper-plane"></i> */}
//             <p className="Send-button-text">Send</p>
//           </button>
//         )}
//       </div>

//       {reportModalVisible && (
//         <div className="User-modal-overlay">
//           <div className="User-modal-content">
//             <h4>Report Message</h4>
//             <textarea
//               placeholder="Enter reason for report..."
//               value={reportText}
//               onChange={(e) => setReportText(e.target.value)}
//             />
//             <div className="User-report-reason-options">
//               {["Abuse", "Threat", "Violence", "Nudity", "Other"].map(
//                 (reason, index) => (
//                   <button
//                     key={index}
//                     onClick={() => setSelectedReason(reason)}
//                     className={`User-reason-option ${
//                       selectedReason === reason ? "selected" : ""
//                     }`}
//                   >
//                     {reason}
//                   </button>
//                 )
//               )}
//             </div>
//             <button
//               onClick={handleSubmitReport}
//               disabled={!reportText.trim()}
//               className="User-submit-report-button"
//             >
//               Submit
//             </button>
//             <button
//               onClick={() => setReportModalVisible(false)}
//               className="User-close-report-button"
//             >
//               Close
//             </button>
//           </div>
//         </div>
//       )}

//       {emptyMessageModalVisible && (
//         <div className="User-modal-overlay">
//           <div className="User-modal-content">
//             <h4>Warning</h4>
//             <p>Please be mindful while sending messages.</p>
//             <button
//               onClick={() => setEmptyMessageModalVisible(false)}
//               className="User-ok-button"
//             >
//               I Understand
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Chat;
import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getUserById, ReportUser } from "../api/api";
import socketServices from "../api/socket";
import { environment } from "../../environments/environments";
import "../Chat/Chat.css";
import userIcon from "../../assets/images/user-icon.png";
import { FaPaperPlane } from "react-icons/fa";

const Chat = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [messages, setMessages] = useState([]);
  const [inputText, setInputText] = useState("");
  const [currUser, setCurrUser] = useState(null);
  const [chatUser, setChatUser] = useState(null);
  const [sending, setSending] = useState(false);
  const [reportModalVisible, setReportModalVisible] = useState(false);
  const [reportMessageId, setReportMessageId] = useState("");
  const [reportText, setReportText] = useState("");
  const [selectedReason, setSelectedReason] = useState("");
  const [emptyMessageModalVisible, setEmptyMessageModalVisible] =
    useState(false);
  const [token, setToken] = useState("");
  const chatContainerRef = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      const userData = localStorage.getItem("currentUser");
      const parsedUserData = JSON.parse(userData);
      setCurrUser(parsedUserData);
      const storedToken = localStorage.getItem("jwtToken");
      console.log("tokenn_generated", storedToken);
      setToken(storedToken || "");
      if (id) {
        const user = await getUserById({ user_id: id });
        console.log(
          "chatuserrrr11",
          JSON.stringify(user.data?.pre_consent_for_displaying_images)
        );
        setChatUser(user?.data);
      }
    };
    fetchData();
  }, [id]);

  useEffect(() => {
    if (!currUser || !chatUser) return;
    socketServices.initializeSocket();
    socketServices.emit("userConnected", currUser._id);
    const messageListener = (data) => {
      if (typeof data === "object" && data !== null) {
        setMessages((prev) => (Array.isArray(prev) ? [...prev, data] : [data]));
      }
    };
    socketServices.on("receiveMessage", messageListener);
    loadChats();
    return () => {
      socketServices.emit("userDisconnected", currUser._id);
    };
  }, [currUser, chatUser]);

  const loadChats = async () => {
    try {
      const res = await fetch(
        `${environment.chatBaseUrl}/chats/${currUser._id || currUser.id}/${
          chatUser._id || chatUser.id
        }`
      );
      const chats = await res.json();
      if (Array.isArray(chats)) {
        if (chats.length === 0) {
          setEmptyMessageModalVisible(true);
        }
        setMessages(chats);
      } else {
        console.warn("Unexpected response from chat API:", chats);
        setMessages([]);
      }
    } catch (error) {
      console.error("Error fetching chats:", error);
      setMessages([]);
    }
  };

  const sendMessage = async () => {
    if (!inputText.trim() || sending) return;
    setSending(true);
    const messageData = {
      from: currUser._id || currUser.id,
      to: chatUser._id || chatUser.id,
      msg: inputText.trim(),
      jwtsecret: token,
      connected_user_status: "approved",
      chatmode: "user",
      sender_id: currUser._id || currUser.id,
    };
    console.log("messageData22222222222222", messageData);
    try {
      const response = await fetch(`${environment.chatBaseUrl}/send-message`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(messageData),
      });

      const responseData = await response.json();
      if (responseData) {
        setInputText("");
        socketServices.emit("sendMessage", messageData);
      }
    } catch (error) {
      console.error("Error sending message:", error);
    } finally {
      setSending(false);
    }
  };

  useEffect(() => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop =
        chatContainerRef.current.scrollHeight;
    }
  }, [messages]);

  const handleReportMessage = (messageId) => {
    setReportMessageId(messageId);
    setReportText("");
    setSelectedReason("");
    setReportModalVisible(true);
  };

  const handleSubmitReport = async () => {
    const value = {
      user_id: currUser?._id || currUser?.id,
      reported_user_id: chatUser._id || chatUser.id,
      message_id: reportMessageId,
      description: reportText,
      reason: selectedReason,
      reported_type: "user",
      reporter_type: "user",
    };

    try {
      console.log("report____", value);
      const res = await ReportUser(value);
      console.log("resss", res);
      if (res?.success) {
        alert("Reported Successfully");
        setReportModalVisible(false);
      }
    } catch (error) {
      console.error("Report error:", error);
    }
  };

  const renderMessage = (message) => {
    console.log("messagessss", message);

    console.log("message.sender_id", message.sender_id);
    console.log("currUser._id", currUser._id || currUser.id);
    const currentUserId = currUser._id || currUser.id;
    const isSentByCurrentUser = message.sender_id === currentUserId;
    console.log("isSendByCurrentUser", isSentByCurrentUser);
    return (
      <div
        key={message._id || message.timestamp}
        className={`User-chat-message ${
          isSentByCurrentUser ? "sent-message" : "received-message"
        }`}
      >
        {!isSentByCurrentUser && (
          <button
            onClick={() => handleReportMessage(message._id)}
            className="User-report-button-chat"
            title="Report message"
          >
            <span>⋮</span>
          </button>
        )}

        <div className="User-message-content">
          <p
            className={
              isSentByCurrentUser
                ? "User-message-text-sent"
                : "User-message-text-receive"
            }
          >
            {message.msg}
          </p>
          <span
            className={
              isSentByCurrentUser
                ? "User-message-time-sent"
                : "User-message-time-receive"
            }
          >
            {new Date(message.timestamp).toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            })}
          </span>
        </div>
      </div>
    );
  };

  if (!currUser || !chatUser) return <div>Loading chat...</div>;

  return (
    <div className="User-chat-container">
      <div className="User-chat-header">
        <div className="User-user-profile">
          {chatUser?.pre_consent_for_displaying_images === true ? (
            <img
              src={`${environment.url}/uploads/users/${chatUser?.more_images?.[0]}`}
              alt="Profile"
              className="User-profile-image"
            />
          ) : (
            <img src={userIcon} alt="Profile" className="User-profile-image" />
          )}

          <div>
            <h3>{chatUser?.name}</h3>
          </div>
        </div>
      </div>

      <div className="User-chat-messages" ref={chatContainerRef}>
        {Array.isArray(messages) &&
          messages
            .filter((item) => item?.msg?.trim?.())
            .map((item) => renderMessage(item))}
      </div>

      <div
        className="User-message-input-container"
        style={{ display: "flex", alignItems: "center" }}
      >
        <div className="input-with-icon">
          <input
            type="text"
            placeholder="Type a message..."
            value={inputText}
            onChange={(e) => setInputText(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter" && inputText.trim()) {
                sendMessage();
              }
            }}
          />
          {inputText && (
            <button onClick={sendMessage} className="icon-button">
              <FaPaperPlane size={20} />
            </button>
          )}
        </div>
      </div>

      {reportModalVisible && (
        <div className="User-modal-overlay">
          <div className="User-modal-content">
            <h4>Report Message</h4>
            <textarea
              placeholder="Enter reason for report..."
              value={reportText}
              onChange={(e) => setReportText(e.target.value)}
            />
            <div className="User-report-reason-options">
              {["Abuse", "Threat", "Violence", "Nudity", "Other"].map(
                (reason, index) => (
                  <button
                    key={index}
                    onClick={() => setSelectedReason(reason)}
                    className={`User-reason-option ${
                      selectedReason === reason ? "selected" : ""
                    }`}
                  >
                    {reason}
                  </button>
                )
              )}
            </div>
            <button
              onClick={handleSubmitReport}
              disabled={!reportText.trim()}
              className="User-submit-report-button"
            >
              Submit
            </button>
            <button
              onClick={() => setReportModalVisible(false)}
              className="User-close-report-button"
            >
              Close
            </button>
          </div>
        </div>
      )}

      {emptyMessageModalVisible && (
        <div className="User-modal-overlay">
          <div className="User-modal-content">
            <div className="warningx">
              <h4>⚠️ Warning</h4>
              <button
                className="chat-cross-button"
                // onClick={() => setEmptyMessageModalVisible(false)}
                onClick={() => navigate("/Sidebar/Messages")}
              >
                ✖
              </button>
            </div>

            <p>Please be mindful while sending messages.</p>

            <ul className="user-warning-list">
              <li>Do not send empty messages.</li>
              <li>Avoid using abusive language.</li>
              <li>Threatening or violent messages are prohibited.</li>
              <li>Maintain respectful communication.</li>
            </ul>
            <button
              onClick={() => setEmptyMessageModalVisible(false)}
              className="User-ok-button"
            >
              I Understand
            </button>
          </div>
          {/* <div className="user-modal-content">
            <button
              className="user-cross-button"
              onClick={() => setEmptyMessageModalVisible(false)}
            >
              ✖
            </button>

            <h4>⚠️ Warning</h4>
            <p>Please be mindful while sending messages.</p>

            <ul className="user-warning-list">
              <li>Do not send empty messages.</li>
              <li>Avoid using abusive language.</li>
              <li>Threatening or violent messages are prohibited.</li>
              <li>Maintain respectful communication.</li>
            </ul>

            <button
              onClick={() => setEmptyMessageModalVisible(false)}
              className="user-ok-button"
            >
              I Understand
            </button>
          </div> */}
        </div>
      )}
    </div>
  );
};

export default Chat;
